export default {"src":"/_next/static/media/panda.0314edcf.svg","height":39,"width":60,"blurWidth":0,"blurHeight":0};